import { FC } from 'react';

import { InsuredMemberBase } from '@store/proposal/types';
import { Badge, Divider, Group, Stack, Text, dayjs } from '@ui';
import { DATE_DISPLAY_FORMAT } from '@utils/constants';

import classes from './MemberDetails.module.css';

export interface MemberDetailsProps {
  member: InsuredMemberBase;
}

const MemberDetails: FC<MemberDetailsProps> = ({ member }) => {
  const noOfYearsToDate = dayjs().diff(dayjs(member.dob), 'years');
  const noOfDaysToDate = dayjs().diff(dayjs(member.dob), 'days');
  let elapsedText = null;
  if (noOfYearsToDate > 0) {
    elapsedText = `${noOfYearsToDate} Year${noOfYearsToDate > 1 ? 's' : ''}`;
  } else if (noOfDaysToDate > 0) {
    elapsedText = `${noOfDaysToDate} Day${noOfDaysToDate > 1 ? 's' : ''}`;
  } else if (dayjs(member.dob).isToday()) {
    elapsedText = 'Today';
  }

  return (
    <Group justify="flex-start">
      <Stack gap={12}>
        <Text fz={13} lh={1}>
          Date of birth
        </Text>
        <Group>
          <Text fz={15} fw={600} lh={1}>
            {dayjs(member.dob).format(DATE_DISPLAY_FORMAT)}
          </Text>
          <Badge
            className={classes.memberDetailsBadge}
            color="primary"
            radius="xs"
            variant="light"
          >
            {elapsedText}
          </Badge>
        </Group>
      </Stack>
      <Divider orientation="vertical" />
      <Stack gap={12}>
        <Text fz={13} lh={1}>
          Relationship
        </Text>
        <Text fz={15} fw={600} lh={1}>
          {member.relation}
        </Text>
      </Stack>
    </Group>
  );
};

export { MemberDetails };
